<div *ngIf="!areAllFiltersEmpty()">
    <div class="filter-by-container">
        <hr *ngIf="isMobileResolution;" style="height:1px;margin-top: 10px;margin-bottom: 19px;border-width:0;color:gray;background-color:gray">
        <p class="rps-paragraph-one rps-mark-bold filter-by-title">Filtered by:</p>
        <a role="button" tabindex="0" class="clear-filters-btn" href="javascript:void(0)" (click)="clearFilters()" aria-label="Clear filters">
            <p class="clear-filters-text">Clear filters</p>
            <c11n-icon class="clear-filters-icon" [name]="'refresh'" size="small" scale="normal" altText="Refresh"></c11n-icon>
        </a>
    </div>

    <div class="current-filter-list">
        <ng-container *ngIf="!isNonVanguard">
        <span *ngFor="let label of strategyFilterLabels">
            <a *ngIf="activeFilters.strategy.controls[label].value" href="javascript:void(0)" role="button" attr.aria-label="strategy filter {{label}} is selected, press enter to unselect" class="filter-item-chip" (click)="removeFromArray(activeFilters.strategy, strategy_item)">
                <p (click)="activeFilters.strategy.controls[label].setValue(false)" class="rps-paragraph-three rps-mark-bold">{{filterMap[label]}} &times;</p>
            </a>
        </span>
        </ng-container>
        <ng-container *ngIf="!isNonVanguard">
            <span *ngFor="let label of strategy529FilterLabels">
                <a *ngIf="activeFilters.strategy529.controls[label].value" href="javascript:void(0)" role="button" attr.aria-label="529 strategy filter {{label}} is selected, press enter to unselect" class="filter-item-chip" (click)="removeFromArray(activeFilters.strategy529, strategy_529_item)">
                    <p (click)="activeFilters.strategy529.controls[label].setValue(false)" class="rps-paragraph-three rps-mark-bold">{{filterMap[label]}} &times;</p>
                </a>
            </span>
            </ng-container>
        <ng-container *ngIf="!isNonVanguard">
            <span *ngFor="let label of managementStyleFilterLabels">
                <a *ngIf="activeFilters.managementStyle.controls[label].value" href="javascript:void(0)" role="button" attr.aria-label="managementStyle filter {{label}} is selected, press enter to unselect" class="filter-item-chip"
                    (click)="activeFilters.managementStyle.controls[label].setValue(false)"><p class="rps-paragraph-three rps-mark-bold">{{label}} &times;</p>
            </a>
            </span>
        </ng-container>
        <ng-container>
            <span *ngFor="let label of assetClassFilterLabels">
              <a *ngIf="activeFilters.assetClass.controls[label].value" href="javascript:void(0)" role="button" attr.aria-label="assetClass filter {{label}} is selected, press enter to unselect" class="filter-item-chip"
                  (click)="clearAssetClass(label)">
                  <p class="rps-paragraph-three rps-mark-bold" >{{formatFilterValue(label)}} &times;</p>
            </a>
            <span *ngIf="label === 'equity'">
                <span *ngFor="let marketCap of marketSubFilterLabels">
                <a *ngIf="activeFilters.assetClassMarketCap[label].controls[marketCap].value" href="javascript:void(0)" role="button" attr.aria-label="assetClass {{label}} sub filter {{marketCap}} is selected, press enter to unselect" class="filter-item-chip"
                (click)="activeFilters.assetClassMarketCap[label].controls[marketCap].setValue(false)"><p class="rps-paragraph-three rps-mark-bold">{{marketCap}} &times;</p></a>
            </span>
            <span *ngFor="let style of styleSubFilterLabels">
                <a *ngIf="activeFilters.assetClassStyle[label].controls[style].value" href="javascript:void(0)" role="button" attr.aria-label="assetClass {{label}} sub filter {{style}} is selected, press enter to unselect" class="filter-item-chip"
                (click)="activeFilters.assetClassStyle[label].controls[style].setValue(false)"><p class="rps-paragraph-three rps-mark-bold">{{style}} &times;</p></a>
            </span>
            </span>
            <span *ngIf="label === 'fixed_income'">
                <span *ngFor="let creditquality of creditQualityFilterLabels">
                <a *ngIf="activeFilters.assetClassCredit[label].controls[creditquality].value" href="javascript:void(0)" role="button" attr.aria-label="assetClass {{label}} sub filter {{creditquality}} is selected, press enter to unselect" class="filter-item-chip"
                (click)="activeFilters.assetClassCredit[label].controls[creditquality].setValue(false)"><p class="rps-paragraph-three rps-mark-bold">{{creditquality}} &times;</p></a>
            </span>
            <span *ngFor="let maturity of maturityFilterLabels">
                <a *ngIf="activeFilters.assetClassMaturity[label].controls[maturity].value" href="javascript:void(0)" role="button" attr.aria-label="assetClass {{label}} sub filter {{maturity}} is selected, press enter to unselect" class="filter-item-chip"
                (click)="activeFilters.assetClassMaturity[label].controls[maturity].setValue(false)"><p class="rps-paragraph-three rps-mark-bold">{{maturity}} &times;</p></a>
            </span>
            </span>
            </span>
        </ng-container>
        <ng-container *ngIf="!isNonVanguard">
        <a *ngFor="let risk_item of activeFilters.risk" href="javascript:void(0)" role="button" attr.aria-label="risk filter {{risk_item}} is selected, press enter to unselect" class="filter-item-chip" (click)="removeFromArray(activeFilters.risk, risk_item)">
            <p class="rps-paragraph-three rps-mark-bold">{{risk_item}} &times;</p>
        </a>
        </ng-container>
        <ng-container *ngIf="!isNonVanguard">
            <span *ngFor="let label of investmentMinimumFilters">
                <a *ngIf="activeFilters.investmentMinimums.controls[label].value" href="javascript:void(0)" role="button"attr.aria-label="investmentMinimum filter {{label}} is selected, press enter to unselect" class="filter-item-chip" (click)="activeFilters.investmentMinimums.controls[label].setValue(false)">
                  <p class="rps-paragraph-three rps-mark-bold">{{minimumsMap[label]}} &times;</p>
            </a>
            </span>
        </ng-container>
        <ng-container *ngIf="!isNonVanguard">
            <span *ngFor="let label of shareClassFilterLabels">
                <a *ngIf="activeFilters.shareClass.controls[label].value" href="javascript:void(0)" role="button"attr.aria-label="shareClass filter {{label}} is selected, press enter to unselect" class="filter-item-chip"
                    (click)="activeFilters.shareClass.controls[label].setValue(false)">
                    <p class="rps-paragraph-three rps-mark-bold">{{formatFilterValue(label)}} &times;</p>
            </a>
            </span>
        </ng-container>
        <ng-container>
            <span *ngFor="let label of taxEfficiencyFilterLabels">
                <a *ngIf="activeFilters.taxEfficiency.controls[label].value" href="javascript:void(0)" role="button"attr.aria-label="taxEfficiency filter {{label}} is selected, press enter to unselect" class="filter-item-chip"
                    (click)="activeFilters.taxEfficiency.controls[label].setValue(false)">
                    <p class="rps-paragraph-three rps-mark-bold">{{formatFilterValue(label)}} &times;</p>
            </a>
            </span>
        </ng-container>
        <ng-container>
              <span *ngFor="let label of regionFilterLabels">
                  <a *ngIf="activeFilters.region.controls[label].value" href="javascript:void(0)" role="button"attr.aria-label="region filter {{label}} is selected, press enter to unselect" class="filter-item-chip"
                     (click)="activeFilters.region.controls[label].setValue(false)">
                      <p class="rps-paragraph-three rps-mark-bold">{{formatFilterValue(label)}} &times;</p>
              </a>
              </span>
        </ng-container>
      <ng-container>
        <span *ngFor="let label of productTypeFilterLabels">
            <a *ngIf="activeFilters.productType.controls[label].value && !isNonVanguardMutualFunds" href="javascript:void(0)" role="button" attr.aria-label="productType filter {{label}} is selected, press enter to unselect" class="filter-item-chip"
               (click)="activeFilters.productType.controls[label].setValue(false)">
                <p class="rps-paragraph-three rps-mark-bold">{{formatFilterValue(label)}} &times;</p>
            </a>
        </span>
      </ng-container>

        <ng-container>
            <span *ngIf="isNonVanguardMutualFunds && activeFilters.fundFamily.name">
                <a href="javascript:void(0)" role="button" attr.aria-label="fundFamily filter {{activeFilters.fundFamily.name}} is selected, press enter to unselect" class="filter-item-chip"
                (click)="clearFilters()">
                <p class="rps-paragraph-three rps-mark-bold">{{activeFilters.fundFamily.name}} &times;</p>
                </a>
            </span>
        </ng-container>
    </div>
</div>
